export default {
  hasEnqueuedCashbackAdjustmentReport: false,
  unidades: [],
  filters: {
    units: [],
    segments: [],
    segmentsObjects: [],
    unitsConfiguration: [],
    data: undefined,
    cliente: '',
    pessoa: '',
    fidelidade: '',
    departments: null,
    periodo: 'Mensal',
    products: [],
    noProducts: false,
    channels: null,
    campaigns: [],
    categories: [],
    couponStatus: ['RECOVERED', 'NOT_RECOVERED', 'NOT_PROCESSED'],
    industries: [],
    mechanics: [],
    month: '',
    rebateStatus: [],
    segmentType: [],
  },
  categoriasClientes: [],
  clientesCadastrados: {},
  expectedRecoveryDate: null,
  lastUpdate: {},
  userPermissions: [],
  quickAction: {},
  preFilters: {},
  quickActionGroups: [],
  isSelectingQuickActionGroups: false,
  dateFilterSelectedPeriod: '',
  smartClientId: 78899,
  franchiseePermissionsRoutes: {
    offers_mobile: 'mobile/ofertas/destaques',
    banners_mobile: 'mobile/banners',
    performance_mobile: 'mobile/desempenho',
    push_campaigns: 'campanhas/aplicativo',
    flyers_campaigns: 'mobile/encartes',
    edit_cashback: 'mobile/cashback/ajustes',
    edit_points: 'clientes/gerenciamento/cadastros/edicao-pontos',
    edit_user_register: 'clientes/gerenciamento/cadastros/edicao-cadastros',
    managing_user_requests: 'clientes/gerenciamento/solicitacoes',
    edit_offers_mobile_units: 'mobile/ofertas/produtos/edicao-lojas-franquia',
    view_offers_schedule_trade_results: 'industria/ofertas_trade/resultados_franquia',
  },
  franchiseePermissions: {
    offers_mobile: false,
    banners_mobile: false,
    performance_mobile: false,
    push_campaigns: false,
    flyers_campaigns: false,
    edit_cashback: false,
    edit_points: false,
    edit_user_register: false,
    edit_offers_mobile_units: false,
    managing_user_requests: true,
    view_offers_schedule_trade_results: false,
  },
  maintenanceReturnForecast: '',
  maintenanceModules: [],
  maintenanceAccountIds: [],
}
